import { render, staticRenderFns } from "./PermissionMenu.vue?vue&type=template&id=11dcf2cc&scoped=true&"
import script from "./PermissionMenu.vue?vue&type=script&lang=js&"
export * from "./PermissionMenu.vue?vue&type=script&lang=js&"
import style0 from "./PermissionMenu.vue?vue&type=style&index=0&id=11dcf2cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dcf2cc",
  null
  
)

export default component.exports